/**
 * @generated SignedSource<<7b7fc458fbe7c1faed3de29018c639a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type github_type = "issue" | "pullrequest" | "branch" | "%future added value";
export type github_type_mutation = "issue" | "pullrequest" | "branch" | "%future added value";
export type CreateGithubAttachedObjectInput = {
  taskId?: string | null;
  githubId?: string | null;
  githubRepo?: string | null;
  githubType?: github_type_mutation | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createGithubAttachedObjectMutation$variables = {
  input: CreateGithubAttachedObjectInput;
};
export type createGithubAttachedObjectMutation$data = {
  readonly createGithubAttachedObject: {
    readonly githubAttachedObject: {
      readonly node: {
        readonly id: string | null;
        readonly number: string | null;
        readonly title: string | null;
        readonly repo: string | null;
        readonly url: string | null;
        readonly createdBy: string | null;
        readonly type: github_type | null;
        readonly status: string | null;
        readonly state: string | null;
        readonly base: string | null;
        readonly head: string | null;
      } | null;
    } | null;
  } | null;
};
export type createGithubAttachedObjectMutation = {
  variables: createGithubAttachedObjectMutation$variables;
  response: createGithubAttachedObjectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGithubAttachedObjectPayload",
    "kind": "LinkedField",
    "name": "createGithubAttachedObject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GithubAttachedObjectTypeEdge",
        "kind": "LinkedField",
        "name": "githubAttachedObject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GithubAttachedObject",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "repo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "base",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "head",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createGithubAttachedObjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createGithubAttachedObjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "be8434a2210528341fd1695e12033cd1",
    "id": null,
    "metadata": {},
    "name": "createGithubAttachedObjectMutation",
    "operationKind": "mutation",
    "text": "mutation createGithubAttachedObjectMutation(\n  $input: CreateGithubAttachedObjectInput!\n) {\n  createGithubAttachedObject(input: $input) {\n    githubAttachedObject {\n      node {\n        id\n        number\n        title\n        repo\n        url\n        createdBy\n        type\n        status\n        state\n        base\n        head\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "458a5335fc1a291454a5e81485f2dcc3";

export default node;
